module.exports = __webpack_public_path__ + "img/discover.009b15c8.png";